export const colors = {
  // Primary wedding colors
  primary: {
    gold: '#caad91',        // Main gold/tan color for text and accents 
    darkTan: '#b8a28a',     // Darker tan for hovers and secondary elements
    lightTan: '#ddc9b4',    // Light background tan
    lightGold: '#eac89f',   // Light gold accent
    mediumBrown: '#a89a85', // Medium brown for elements
  },
  
  // Neutral colors
  neutral: {
    darkOlive: '#26270F',   // Very dark olive/black for text and elements
    darkBrown: '#1c1912',   // Dark brown for backgrounds and text
    cream: '#F5F2E8',       // Off-white/cream for light text
    black: '#000000',       // Pure black
  },
  
  // API feedback colors
  api: {
    error: '#8B2635',       // Dark maroon red for error messages
  },
  
  // Legacy colors (from GlobalStyles - may want to phase out)
  legacy: {
    lightGray: '#f8f9fa',
    mediumGray: '#e9ecef',
    darkBlue: '#2c3e50',
    red: '#e74c3c',
    darkRed: '#c0392b',
  }
} as const;

// Helper function to convert hex to rgba
const hexToRgba = (hex: string, alpha: number): string => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

// Pre-defined transparent color variations for common use cases
export const transparentColors = {
  darkBrownBorder: hexToRgba(colors.neutral.darkBrown, 0.2), // For borders
  darkBrownLight: hexToRgba(colors.neutral.darkBrown, 0.1),  // For very light backgrounds
  goldLight: hexToRgba(colors.primary.gold, 0.3),           // For light gold overlays
} as const;

// Type helper for accessing colors
export type ColorPalette = typeof colors;
export type PrimaryColors = keyof typeof colors.primary;
export type NeutralColors = keyof typeof colors.neutral;
export type ApiColors = keyof typeof colors.api;
export type LegacyColors = keyof typeof colors.legacy; 